<script setup lang="ts">
	import moment from "moment";

	const props = withDefaults(
		defineProps<{
			categories: string[];
			data: number[];
			chartKey?: string;
		}>(),
		{
			categories: () => [] as string[],
			data: () => [] as number[],
			chartKey: () => "",
		}
	);

	// const colors = computed(() => {
	// 	return props.data.map((v, i) => {
	// 		if (i === props.data.length - 1) return "#5963D9";
	// 		else return "#5963D960";
	// 	});
	// });

	const label = computed(() => {
    return props.categories;
  });

	const chartOptions = 
    computed(() => {
      return   {
		chart: {
			animations: {
				enabled: false,
			},
			type: "area",
			toolbar: {
				show: false,
			},
			selection: {
				enabled: false,
			},
      zoom: false,
		},
    colors: ['#007ce1'],
		stroke: {
			width: 2,
		},
		tooltip: {
			enabled: true,
		},
		grid: {
			show: true,
			padding: {
				top: 0,
				right: 10,
				bottom: 0,
				left: 0,
			},
		},
    
    fill:{
      colors: ['rgba(30, 72, 65, 0.16)', 'rgba(30, 72, 65, 0.00)']
      // fill: linear-gradient(180deg, rgba(30, 72, 65, 0.16) -0.21%, rgba(30, 72, 65, 0.00) 100%);
    },
		dataLabels: {
			enabled: false,
			enabledOnSeries: [1],
		},
		// labels: props.categories,
		labels: label.value,
		xaxis: {
			tickAmount: 8,
			axisTicks: {
				show: false,
			},
			labels: {
				show: true,
				offsetY: 0,
				rotate: 0,
				style: {
					fontSize: "10px",
				},

			},
		},
		legend: {
			position: "top",
			fontSize: "12px",
			markers: {
				width: 20,
				height: 3,
			},
		},
		markers: {
			shape: "circle",
			size: 0,
			radius: 4,
			strokeWidth: 0,
			strokeOpacity: 0.9,
			strokeDashArray: 0,
		},
		yaxis: [
			{
				showAlways: true,
				labels: {
					style: {
						fontSize: "10px",
					},
					formatter: function(value: number) {
						return value ? value.toFixed(0) : '';
					},
					offsetX: -10,
				},
				axisTicks: {
					show: true,
				},
				axisBorder: {
					show: true,
				},
			},
		],
	};
    })


	const series = computed(() => {
		return [
			{
				name: props.chartKey,
				data: props.data,
			},
		];
	});
</script>

<template>
<!-- {{ series[0].data }} -->
  <!-- {{ label }} -->
	<ClientOnly>
		<apexchart type="area" :options="chartOptions" :series="series" height="70%"></apexchart>
	</ClientOnly>
</template>
